import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useSite, absoluteUrl } from "../context/SiteContext";

export default function Footer() {
  const { settings, services } = useSite();
  const brand = settings.brand;
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#1F3550] bg-[#050A0F]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={absoluteUrl(brand.logoUrl)}
              alt={brand.name}
              className="h-14 w-14 object-contain"
            />
            <div>
              <div className="font-heading font-black text-lg tracking-wider">
                {brand.name}
              </div>
              <div className="font-mono text-[10px] tracking-[0.3em] text-[#F39C12] uppercase">
                {brand.tagline}
              </div>
            </div>
          </div>
          <p className="text-sm text-[#94A3B8] leading-relaxed">
            A leading industrial construction and engineering company since {brand.established},
            headquartered in {brand.city}. Delivering heavy industrial projects with safety,
            precision and accountability.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#F39C12] uppercase mb-5">
            Services
          </div>
          <ul className="space-y-2">
            {services.map((s) => (
              <li key={s.id}>
                <Link to="/services" className="text-sm text-[#94A3B8] hover:text-[#F8FAFC] transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#F39C12] uppercase mb-5">Company</div>
          <ul className="space-y-2 text-sm text-[#94A3B8]">
            <li><Link to="/about" className="hover:text-[#F8FAFC]">About</Link></li>
            <li><Link to="/projects" className="hover:text-[#F8FAFC]">Projects</Link></li>
            <li><Link to="/clients" className="hover:text-[#F8FAFC]">Clients</Link></li>
            <li><Link to="/careers" className="hover:text-[#F8FAFC]">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-[#F8FAFC]">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#F8FAFC]">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#F39C12] uppercase mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-[#94A3B8]">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-[#F39C12] flex-shrink-0" />
              <span>{brand.address}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-[#F39C12] flex-shrink-0" />
              <a href={`tel:${brand.phone}`} className="hover:text-[#F8FAFC]">{brand.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-[#F39C12] flex-shrink-0" />
              <a href={`mailto:${brand.email}`} className="hover:text-[#F8FAFC]">{brand.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1F3550]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs font-mono text-[#64748B] tracking-wider">
            © {new Date().getFullYear()} {brand.name} — ALL RIGHTS RESERVED
          </p>
          <p className="text-xs font-mono text-[#64748B] tracking-wider">
            {settings.footer_note}
          </p>
        </div>
      </div>
    </footer>
  );
}
